import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-xl border-[1px] mt-4 border-greyScale100 p-6 lg:p-[48.5px] w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg lg:text-2xl text-greyScale900 mt-0 mb-6 text-center" }, " Informacje o wizycie ", -1)
const _hoisted_3 = { class: "w-full flex items-center justify-between mb-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-greyScale900 text-sm lg:text-xl font-medium" }, "Status wizyty:", -1)
const _hoisted_5 = { class: "w-full flex items-center justify-between mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-greyScale900 text-sm lg:text-xl font-medium" }, " Przewidywany termin wizyty: ", -1)
const _hoisted_7 = { class: "text-greyScale600 text-sm lg:text-xl font-normal" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-greyScale500"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-greyScale500"
}


export default {
  __name: 'VisitTracker',
  props: {
    orderData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props;



function getTimeRange(dateString) {
    const date = new Date(dateString);
    const hour = date.getHours();

    const startHour = hour - 1;
    const endHour = hour + 1;

    const formatTime = (h) => h.toString().padStart(2, '0') + ':00';

    return `${formatTime(startHour)}-${formatTime(endHour)}`;
}

function getStatusColor(status) {
    switch (status) {
        case 'Zakończona':
            return 'text-secondary';
        case 'Zarejestrowany':
            return 'text-accentBlue';
        case 'W trakcie':
            return 'text-accentOrange';
        case 'Oczekujący':
            return 'text-accentPurple';
    }
}

function isDateInPast(fromDate) {
    const inputDate = new Date(fromDate);
    const currentDate = new Date();
    return inputDate < currentDate;
}

function formatDate(fromDate) {
    const date = new Date(fromDate);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", {
        class: _normalizeClass(["text-sm lg:text-xl font-normal", getStatusColor(__props.orderData.Status)])
      }, _toDisplayString(__props.orderData.Status), 3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", _hoisted_7, _toDisplayString(formatDate(__props.orderData.FromDate)) + " " + _toDisplayString(getTimeRange(__props.orderData.FromDate)), 1)
    ]),
    (isDateInPast(__props.orderData.FromDate) && __props.orderData.Status === 'W trakcie')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Przepraszamy za opóźnienie Twojej wizyty. Rozumiemy, jak cenny jest Twój czas, i pracujemy nad jak najszybszym rozwiązaniem tej sytuacji. Wkrótce zostaniesz poinformowany o aktualnym statusie. "))
      : _createCommentVNode("", true),
    (__props.orderData.Status === 'Zarejestrowany')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Twoja wizyta została zarejestrowana pomyślnie. Jesteśmy gotowi, aby zapewnić Ci profesjonalną opiekę. Do zobaczenia wkrótce! "))
      : _createCommentVNode("", true)
  ]))
}
}

}